import Footer from '@frontend/storefront/components/layout/footer';

export default function SearchLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <div className="np-section">
        <div className="np-container min-h-[50vh]">{children}</div>
      </div>
      <Footer />
    </>
  );
}
